import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function isUserImpersonated() {
  return restApiClient.url(constructApiUrl(API.auth.isUserImpersonated.url, null)).get<boolean>()
}
